import create from "zustand";
import produce from "immer";

export const storeCreator = (creator) =>
  create((set, get) => creator((fn) => set(produce(fn)), get));
